module.exports = __webpack_public_path__ + "img/imgdunac.06e7929b.png";